import { render, staticRenderFns } from "./AppEmployeeProfileCard.vue?vue&type=template&id=3bc57f16&"
import script from "./AppEmployeeProfileCard.vue?vue&type=script&lang=js&"
export * from "./AppEmployeeProfileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports